<div class="selection {{ theme }} {{ mods | join: ' '}}" *ngFor="let switchItem of switchList; let i=index;" [ngClass]="{ 'selected' : switchItem.isSwitchActive }" (click)="toggle(switchItem, i)">
    {{ switchItem.switchName | replace:' ':'&nbsp;'}}
</div>
